import React from 'react';
import { Section } from '../ui/Section';
import { Check, X } from 'lucide-react';
export function WhoFor() {
  const forWho = ["Renters who are sick of paying their landlord's mortgage every month.", 'First-time buyers who have good credit but are tired of the "20% down" lie.', 'Young families who need more space but have been priced out of the retail market.', 'Small-scale investors looking for their first "undermarket" win.'];
  const notFor = ['People looking for a "move-in ready" mansion for the price of a used car.', 'Corporate hedge funds looking to exploit the little guy.', 'Anyone unwilling to do 30 minutes of "digital detective work" on public records.'];
  return <Section theme="black" className="border-b border-gold-hairline" data-id="element-204">
      <div className="grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-205">
        {/* Who this is FOR */}
        <div className="bg-onyx p-8 md:p-10 shadow-editorial-dark border border-gold-hairline border-t-[1px] border-t-gold" data-id="element-206">
          <h3 className="text-2xl font-serif font-medium mb-10 text-bone pb-6 border-b border-gold-hairline" data-id="element-207">
            Who This Is For
          </h3>
          <ul className="space-y-6" data-id="element-208">
            {forWho.map((item, idx) => <li key={idx} className="flex gap-4 items-start" data-id="element-209">
                <div className="shrink-0 mt-1" data-id="element-210">
                  <Check className="w-5 h-5 text-gold" strokeWidth={2} data-id="element-211" />
                </div>
                <span className="text-bone-muted text-lg leading-relaxed" data-id="element-212">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Who this is NOT for */}
        <div className="bg-graphite p-8 md:p-10 border border-gold-hairline" data-id="element-213">
          <h3 className="text-2xl font-serif font-medium mb-10 text-bone-muted pb-6 border-b border-gold-hairline/50" data-id="element-214">
            Who This Is NOT For
          </h3>
          <ul className="space-y-6" data-id="element-215">
            {notFor.map((item, idx) => <li key={idx} className="flex gap-4 items-start" data-id="element-216">
                <div className="shrink-0 mt-1" data-id="element-217">
                  <X className="w-5 h-5 text-bone-muted/40" strokeWidth={2} data-id="element-218" />
                </div>
                <span className="text-bone-muted/60 text-lg leading-relaxed" data-id="element-219">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}